import { render } from "./group-policy-drawer.vue?vue&type=template&id=6657873c&scoped=true&ts=true"
import script from "./group-policy-drawer.vue?vue&type=script&lang=ts"
export * from "./group-policy-drawer.vue?vue&type=script&lang=ts"

import "./group-policy-drawer.vue?vue&type=style&index=0&id=6657873c&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6657873c"]])

export default __exports__